var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skill"},[_c('img',{attrs:{"src":require('@/' + _vm.src),"alt":"安评"}}),_c('div',{staticClass:"container"},[_c('div',{directives:[{name:"add-class",rawName:"v-add-class",value:('shake'),expression:"'shake'"}],staticClass:"animated"},[_c('i',{class:_vm.icon}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }